export default "__VITE_ASSET__$D7IiyOK__"